module.exports = __webpack_public_path__ + "static/section01-f539657dc301fa8fd19cf29b8f95c5aa.jpg";